import { useQuery } from "@tanstack/react-query";
import { fetchPublicPostInfo } from "../../../services/b2b-social-apiServices";

const useGettingPostInfo = (postId) => {
    const getPostInfo = async (postId) => {
        const info = await fetchPublicPostInfo(postId);
        return info;
    }

    const { data: postInfo, isLoading, isError } = useQuery({
        queryKey: ['fetchPublicPostInfo', postId],
        queryFn: () => getPostInfo(postId),
        enabled: !!postId,
    });
        
    return { postInfo, isLoading, isError };

}

export default useGettingPostInfo;